import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import type { PublicUser } from "../shared/types";
import { api } from "./lib/api";
import { WelcomePage } from "./pages/WelcomePage";
import { ConsumerApp } from "./pages/ConsumerApp";
import { BrandStudio } from "./pages/BrandStudio";
import { PassportPage } from "./pages/PassportPage";
import { LegalPage } from "./pages/LegalPage";
import { SharedFitPassPage } from "./pages/SharedFitPassPage";
import { ProductDemoPage } from "./pages/ProductDemoPage";
import { ProductionStudio } from "./pages/ProductionStudio";
import { AccessPage } from "./pages/AccessPage";

export function App() {
  const [user, setUser] = useState<PublicUser | null | undefined>(undefined);
  const location = useLocation();
  useEffect(() => { api<{ user: PublicUser | null }>("/auth/me").then((result) => setUser(result.user)).catch(() => setUser(null)); }, []);
  if (user === undefined) return <div className="splash"><span>FITYOUX</span></div>;
  return <Routes>
    <Route path="/" element={<WelcomePage user={user} onAuthenticated={setUser} />} />
    <Route path="/demo/tshirt" element={<ProductDemoPage user={user} onAuthenticated={setUser} />} />
    <Route path="/share/fit/:token" element={<SharedFitPassPage />} />
    <Route path="/privacy" element={<LegalPage kind="privacy" />} />
    <Route path="/terms" element={<LegalPage kind="terms" />} />
    <Route path="/access" element={user ? <Navigate to={user.role === "brand" ? "/studio" : "/app"} replace /> : <AccessPage onAuthenticated={setUser} />} />
    <Route path="/p/:code" element={<PassportPage user={user} />} />
    <Route path="/app/*" element={user?.role === "consumer" ? <ConsumerApp user={user} onLogout={() => setUser(null)} /> : <Navigate to="/" state={{ from: location }} replace />} />
    <Route path="/studio/production" element={user?.role === "brand" ? <ProductionStudio user={user} onLogout={() => setUser(null)} /> : <Navigate to="/" replace />} />
    <Route path="/studio/*" element={user?.role === "brand" ? <BrandStudio user={user} onLogout={() => setUser(null)} /> : <Navigate to="/" replace />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>;
}
